import keycloakAxios from '@/services/axios';

export const getCompanyStatistics = async (companyId: string) => {
  let endpoint = `company/statistics`;

  if (companyId) {
    endpoint = `company/${companyId}/statistics`;
  }

  const response = await keycloakAxios.get(endpoint);
  if (response.status >= 300) {
    throw new Error(
      `Error getting company statistics. Invalid status code: ${response.status}`
    );
  }
  return response.data;
};
